module.exports = __webpack_public_path__ + "img/logo_.706836d1.jpg";